/**
* @name: link-text
* @author: weiyong
* @date: 2023-03-06 16:59
* @description：link-text
* @update: 2023-03-06 16:59
*/
<template>
  <div class="link-text">
    <div @click="clickLink" v-if="showCols[propName]&&showCols[propName].propType==='link'" class="common-link">
      <grid-cell-ctl-show :column="showCols[propName]" :defContent="t('记录内容')" :record="record"/>
    </div>
    <div v-else>
      {{ (showCols[propName]&&record[showCols[propName].propId]) || t('记录内容') }}
    </div>
    <iframe-modal v-if="winVisible"
                  :windowWidth="windowWidth"
                  :windowUrl="windowUrl"
                  :windowTitle="windowTitle"
                  :windowHeight="windowHeight"
                  v-model:visible="winVisible"></iframe-modal>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "link-text",
});
</script>

<script lang="ts" setup>
import GridCellCtlShow from "@/main-page/gridCellCtlShow/index.vue";
import {toRefs} from 'vue';
import {useI18n} from "vue-i18n";
import {useOpenWin} from "@/gateway-main/components/hooks/useOpenWin";
import IframeModal from "@/gateway-main/commonVue/iframe-modal.vue";

const {t} = useI18n();

interface propTypes {
  showCols:any,
  record: any,
  propName:any,
  dataConfig: any
};
const props = withDefaults(defineProps<propTypes>(), {
  record:{},
  showCols: {},
  propName:{},
  dataConfig: {}
})
const {showCols} = toRefs(props);


const {
  windowTitle,
  windowWidth,
  windowHeight,
  windowUrl,
  winVisible,
  openLink
} = useOpenWin();

//链接点击事件
const clickLink = function () {
  if ((unref(showCols)[props.propName] as any).openType === 'win') {
    openLink(unref(showCols)[props.propName]);
  }
}
</script>

